<template>
    <div class="resource-content">
        <div class="container">
            <div class="clearfix"></div>
            <div class="row">
                <div class="col-sm-7">
                    <div class="container-responsive">
                        <h3 v-bind:style="{ color: $a11yTextColor(getCorpHeadingColor),  backgroundColor: getCorpHeadingColor}">Set the Tone of Your Life</h3>
                        <div v-if="getAllFeaturedArticles" v-for="fa in getAllSetToneResources">
                        <h4 v-if="fa.articleHeader" v-bind:style="{'borderBottom': '2px solid ' + getCorpHeaderColor + ' !important'}"><a  v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" :href="fa.articleUrl" :title="fa.articleHeader" target="_blank">{{fa.articleHeader}}</a></h4>
                        <div class="row" v-if="fa.articleHeader">
                            <div class="col-sm-6" v-if="fa.imageUrl"><img :src="fa.imageUrl" :alt="fa.articleHeader" :title="fa.articleHeader"/></div>
                            <div class="col-sm-6" v-if="fa.description">{{fa.description}}<br><a  v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" :href="fa.articleUrl" target="_blank">(more)</a> </div>
                        </div>
                            <div class="clearfix"></div>
                        </div>
                        <h3 v-bind:style="{ color: $a11yTextColor(getCorpHeadingColor),  backgroundColor: getCorpHeadingColor}">Featured Articles</h3>
                        <div v-if="getAllSetToneResources" v-for="fa in getAllFeaturedArticles">
                            <h4 v-bind:style="{'borderBottom': '2px solid ' + getCorpHeaderColor + ' !important'}" v-if="fa.articleHeader"><a  v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" :href="fa.articleUrl" :title="fa.articleHeader" target="_blank">{{fa.articleHeader}}</a></h4>
                            <div class="row" v-if="fa.articleHeader">
                                <div class="col-sm-6" v-if="fa.imageUrl"><img :src="fa.imageUrl" :alt="fa.articleHeader" :title="fa.articleHeader"/></div>
                                <div class="col-sm-6" v-if="fa.description">{{fa.description}}<br><a  v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" :href="fa.articleUrl" target="_blank">(more)</a> </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
<!--                        <h4 v-if="article1_header"><a :href="article1_url" :title="article1_header" target="_blank">{{article1_header}}</a></h4>-->
<!--                        <div class="row" v-if="article1_header">-->
<!--                            <div class="col-sm-6"><img :src="article1_img" :alt="article1_header" :title="article1_header"/></div>-->
<!--                            <div class="col-sm-6">{{article1_text}}<br><a :href="article1_url" target="_blank">(more)</a> </div>-->
<!--                        </div>-->
<!--                        <div class="clearfix"></div>-->
<!--                        <h4 v-if="article2_header"><a :href="article2_url" :title="article2_header" target="_blank">{{article2_header}}</a></h4>-->
<!--                        <div class="row" v-if="article2_header">-->
<!--                            <div class="col-sm-6"><img :src="article2_img" :alt="article2_header" :title="article2_header"/></div>-->
<!--                            <div class="col-sm-6">{{article2_text}}<br><a :href="article2_url" target="_blank">(more)</a> </div>-->
<!--                        </div>-->
<!--                        <div class="clearfix"></div>-->
<!--                        <h4 v-if="article3_header"><a :href="article3_url" :title="article3_header" target="_blank">{{article3_header}}</a></h4>-->
<!--                        <div class="row" v-if="article3_header">-->
<!--                            <div class="col-sm-6"><img :src="article3_img" :alt="article3_header" :title="article3_header"/></div>-->
<!--                            <div class="col-sm-6">{{article3_text}}<br><a :href="article3_url" target="_blank">(more)</a> </div>-->
<!--                        </div>-->
<!--                        <h4 v-if="article4_header"><a :href="article4_url" :title="article4_header" target="_blank">{{article4_header}}</a></h4>-->
<!--                        <div class="row" v-if="article4_header">-->
<!--                            <div class="col-sm-6"><img :src="article4_img" :alt="article4_header" :title="article4_header" /></div>-->
<!--                            <div class="col-sm-6">{{article4_text}}<br><a :href="article4_url" target="_blank">(more)</a> </div>-->
<!--                        </div>-->
<!--                        <h4 v-if="article5_header"><a :href="article5_url" :title="article5_header" target="_blank">{{article5_header}}</a></h4>-->
<!--                        <div class="row" v-if="article5_header">-->
<!--                            <div class="col-sm-6"><img :src="article5_img" :alt="article5_header" :title="article5_header"/></div>-->
<!--                            <div class="col-sm-6">{{article5_text}}<br><a :href="article5_url" target="_blank">(more)</a> </div>-->
<!--                        </div>-->
                        <div class="clearfix"></div>

                        <h3 v-bind:style="{ color: $a11yTextColor(getCorpHeadingColor),  backgroundColor: getCorpHeadingColor}">Resources</h3>
                        <div class="accordionholder">
                            <accordion :one-at-atime="true" type="default">
                                <panel>
                                    <strong slot="header"><u>{{resourceCategory1_text}}</u></strong>
                                    <div v-if="resourceCategory1_links" v-for="link in resourceCategory1_links">
                                        <a v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" target="_blank" :href="link.url">{{link.title}}</a><br>
                                    </div>
                                </panel>
                                <panel header="Panel #2">
                                    <strong slot="header"><u>{{resourceCategory2_text}}</u></strong>
                                    <div v-if="resourceCategory2_links" v-for="link in resourceCategory2_links">
                                        <a v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" target="_blank" :href="link.url">{{link.title}}</a><br>
                                    </div>
                                </panel>
                                <panel header="Panel #3">
                                    <strong slot="header"><u>{{resourceCategory3_text}}</u></strong>
                                    <div v-if="resourceCategory3_links" v-for="link in resourceCategory3_links">
                                        <a v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" target="_blank" :href="link.url">{{link.title}}</a><br>
                                    </div>
                                </panel>
                                <panel header="Panel #4">
                                    <strong slot="header"><u>{{resourceCategory4_text}}</u></strong>
                                    <div v-if="resourceCategory4_links" v-for="link in resourceCategory4_links">
                                        <a v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" target="_blank" :href="link.url">{{link.title}}</a><br>
                                    </div>
                                </panel>
                                <panel header="Panel #5">
                                    <strong slot="header"><u>{{resourceCategory5_text}}</u></strong>
                                    <div  v-if="resourceCategory5_links" v-for="link in resourceCategory5_links">
                                        <a v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" target="_blank" :href="link.url">{{link.title}}</a><br>
                                    </div>
                                </panel>
                                <panel header="Panel #6">
                                    <strong slot="header"><u>{{resourceCategory6_text}}</u></strong>
                                    <div v-if="resourceCategory6_links" v-for="link in resourceCategory6_links">
                                        <a v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" target="_blank" :href="link.url">{{link.title}}</a><br>
                                    </div>
                                </panel>
                            </accordion>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <br>
                </div>
                <div class="col-sm-5 text-left ">
                    <h4 class="text-center">{{video_title}}</h4>
                    <div class="video-holder">
                        <jwplayer id="resourcesvideoplay" v-if="currentVideo" :data="currentVideo">Loading the player...</jwplayer>
                        <img v-if="!currentVideo && video_code.indexOf('http') >= 0" :src="video_code" :alt="video_title" :title="video_title" />
                    </div>
                    <h5 v-if="liveEvent">{{getDateReference(liveEvent.start_date, 'str')}}</h5>
                    <small v-if="liveEvent">{{liveEvent.longDescription}}</small>
                    <div class="text-center smlbuttonholder" v-if="liveEvent && !showJoin(liveEvent)" >
                        <div v-a11y-action v-on:click="calendarLogging($event, liveEvent.title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                        Add to Calendar
                        <span class="start">{{liveEvent.start_date}}</span>
                        <span class="end">{{liveEvent.end_date}}</span>
                        <span class="timezone">America/New_York</span>
                        <span class="title">{{liveEvent.title}}</span>
                        <span class="description">{{liveEvent.longDescription}}</span>
                        <span class="location"><span v-if="liveEvent.type === '1'">{{buildEventLink (liveEvent.eventId) }}</span><span v-else>{{buildEventLink (liveEvent.eventId) }}</span></span>
                    </div>
                        <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal" type="button" class="share-event" v-bind:style="{color: $a11yInkColor(getCorpButtonColor) + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                            <i aria-hidden="true" class="fa fa-share-square-o"></i> Share
                        </button>
                        <div class="clearfix"></div>
                    </div>
                    <div v-else>
                        <div class="clearfix"></div>
                        <button class="button btn btn-pink btn-primary pull-center" :style="styleObject" @mouseenter="updateHoverState(true)" @mouseleave="updateHoverState(false)"  v-if="showJoin(liveEvent)" type="button" @click="joinEvent(liveEvent)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp</button>
                    </div>
                    <div class="clearfix"></div>
                    <div class="advertizmentbox" v-if="firstAdvertisementBox">
                        <jwplayer id="resourcesad1" v-if="firstAdvertisementBox && firstAdvertisementBox.videoCode && firstAdvertisementBox.videoObject" :data="firstAdvertisementBox.videoObject">Loading the player...</jwplayer>
                        <img v-if="firstAdvertisementBox.imageUrl && !firstAdvertisementBox.videoCode" :src="firstAdvertisementBox.imageUrl" :alt="firstAdvertisementBox.articleHeader" :title="firstAdvertisementBox.articleHeader"/>
                        <p v-if= "firstAdvertisementBox.articleHeader" style="padding: 20px;" v-html="firstAdvertisementBox.articleHeader"></p>
                    </div>
                    <div class="clearfix"></div>
                    <h3 v-bind:style="{ color: $a11yTextColor(getCorpHeadingColor),  backgroundColor: getCorpHeadingColor}" id="sFeatures">Site Features</h3>
                    <div></div>
                    <div class="accordionholder">
                        <accordion :one-at-atime="true" type="default">
                            <panel :is-open="openPanel(siteFeatures1_text)">
                                <strong slot="header"><u>{{siteFeatures1_text}}</u></strong>
                                {{siteFeatures1_desc}}
                            </panel>
                            <panel header="Panel #2" :is-open="openPanel(siteFeatures2_text)">
                                <strong slot="header"><u>{{siteFeatures2_text}}</u></strong>
                                {{siteFeatures2_desc}}
                            </panel>
                            <panel header="Panel #3" :is-open="openPanel(siteFeatures3_text)">
                                <strong slot="header"><u>{{siteFeatures3_text}}</u></strong>
                                {{siteFeatures3_desc}}
                            </panel>
                            <panel header="Panel #4" :is-open="openPanel(siteFeatures4_text)">
                                <strong slot="header"><u>{{siteFeatures4_text}}</u></strong>
                                {{siteFeatures4_desc}}
                            </panel>
                            <panel header="Panel #5" :is-open="openPanel(siteFeatures5_text)">
                                <strong slot="header"><u>{{siteFeatures5_text}}</u></strong>
                                {{siteFeatures5_desc}}
                            </panel>
                            <panel header="Panel #6" :is-open="openPanel(siteFeatures6_text)">
                                <strong slot="header"><u>{{siteFeatures6_text}}</u></strong>
                                {{siteFeatures6_desc}}
                            </panel>
                            <panel header="Panel #7" :is-open="openPanel(siteFeatures7_text)">
                                <strong slot="header"><u>{{siteFeatures7_text}}</u></strong>
                                {{siteFeatures7_desc}}
                            </panel>
                        </accordion>
                    </div>
                    <div class="clearfix"></div>
                    <div class="clearfix"></div>
                    <h3 v-bind:style="{ color: $a11yTextColor(getCorpHeadingColor),  backgroundColor: getCorpHeadingColor}" class="adboxheading">Sign Up For Our Newsletter</h3>
                    <form id="footer_form" v-on:submit.prevent="onEmailSignUp">
                        <div class="formholder">
                            <input autocomplete="email" aria-label="Email Address" v-model="subscriptionForm.email" type="email" class="form-control" placeholder="Email Address"  title="please enter a valid email address"  required>
                            <br>
                            <button class="yellowbtn"><strong>Sign Up</strong></button>
                        </div>
                    </form>
                    <div class="clearfix"></div>
                    <div v-for="ad in mediaColl">
                        <div class="advertizmentbox" v-if="ad">
                            <jwplayer  v-if="ad && ad.videoCode && ad.videoObject" :data="ad.videoObject">Loading the player...</jwplayer>
                            <img v-if="ad.imageUrl && !ad.videoCode" :src="ad.imageUrl" :alt="ad.articleHeader" :title="ad.articleHeader"/>
                            <p v-if= "ad.articleHeader" style="padding: 20px;" v-html="ad.articleHeader"></p>
                        </div>
                    </div>
<!--                    <div class="advertizmentbox"  v-if="advertisementBox2_text || advertisementBox2_image || advertisementBox2_video">-->
<!--                        <jwplayer id="resourcesad2" v-if="advertisementVideo2" :data="advertisementVideo2">Loading the player...</jwplayer>-->
<!--                        <img v-if="advertisementBox2_image && !advertisementVideo2" :src="advertisementBox2_image" :alt="advertisementBox2_text" :title="advertisementBox2_text" />-->
<!--                        <p style="padding: 20px;" v-if="advertisementBox2_text" v-html="advertisementBox2_text"></p>-->
<!--                    </div>-->
                    <h3 v-bind:style="{ color: $a11yTextColor(getCorpHeadingColor),  backgroundColor: getCorpHeadingColor}" class="adboxheading">Follow US</h3>
                    <div class="socialblocks">
                        <a aria-label="TONE Networks on facebook (opens in a new window)" href="https://www.facebook.com/tonenetworks/" target="new" v-bind:style="{ backgroundColor: getCorpHeadingColor}">
                            <i aria-hidden="true" class="fa fa-facebook fa-2x"></i>
                        </a>
                        <a aria-label="TONE Networks on twitter (opens in a new window)" href="https://twitter.com/ToneNetworks" target="new" v-bind:style="{ backgroundColor: getCorpHeadingColor}">
                            <i aria-hidden="true" class="fa fa-twitter fa-2x"></i>
                        </a>
                        <a aria-label="TONE Networks on instagram (opens in a new window)" href="https://www.instagram.com/tonenetworks/" target="new" v-bind:style="{ backgroundColor: getCorpHeadingColor}">
                            <i aria-hidden="true" class="fa fa-instagram fa-2x"></i>
                        </a>
                        <a aria-label="TONE Networks on linkedin (opens in a new window)" href="https://www.linkedin.com/company/25037986/" target="new" v-bind:style="{ backgroundColor: getCorpHeadingColor}">
                            <i aria-hidden="true" class="fa fa-linkedin fa-2x"></i>
                        </a>
                        <a aria-label="TONE Networks on youtube (opens in a new window)" href="https://www.youtube.com/channel/UCarjWAb1SWrzKtoeNimOVJA/videos" target="new" v-bind:style="{ backgroundColor: getCorpHeadingColor}">
                            <i aria-hidden="true" class="fa fa-youtube fa-2x"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <modal v-if="showCorporateImageShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateImageShare" @cancel="cancelCorporateImageModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                <i aria-hidden="true" class="fa fa-share-square-o"></i> Share with your Corporate Community Or Friends
                <a v-a11y-action href="javascript:" @click="cancelCorporateImageModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        <select aria-label="Share with" v-model="shareOption" class="form-control strongselec">
                            <option value="Corporate">Share with Community</option>
                            <option value="Individual">Share with Colleagues</option>
                            <option value="Friends">Share with Friends</option>
                        </select>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect aria-label="Corporate recipients" v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Friends'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect aria-label="Email recipients" v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img v-bind:src="user && user.corporation && user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : user.picture" alt="user">&nbsp;&nbsp; <b>{{user.firstName.toLowerCase()}}</b>
                            </td>
                            <!--                            <td>-->
                            <!--                                <b>{{user.firstName.toLowerCase()}}</b>-->
                            <!--                            </td>-->
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <textarea aria-label="Type your message" v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="shareEventSelected.img_url" :alt="shareEventSelected.title" :title="shareEventSelected.title">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${shareEventSelected.title} | TONE Networks`}}</h4>
                        <p> {{`${shareEventSelected.longDescription.substring(0,250)}...`}}</p>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateImageModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn btn-primary btn-pink" :disabled="(shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0 || shareInProcess)) || (shareOption === 'Friends' && (taggedEmails === null || taggedEmails.length === 0 || shareInProcess)) " @click="shareCorporateImage()">
                            Share This Event
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as {{`${user.firstName} ${user.lastName}`}}
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
    </div>
</template>

<script>
    //    import slick from 'slick-carousel'
    import $ from 'jquery'
    import jwplayer from './JwPlayer.vue'
    import { mapGetters } from 'vuex'
    import { dateHelpers } from '../helpers/dateHelpers.js'
    import store from '../store'
    import { accordion } from 'vue-strap'
    import spinner from '@/accessibility/Spinner'
    import panel from '@/accessibility/Panel'
    import input from '@/accessibility/Input'
    import modal from '@/accessibility/Modal'
    // import { FullCalendar } from 'vue-full-calendar'
    //    import moment from 'moment'
    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'accordion': accordion,
            'panel': panel,
            modal,
            // FullCalendar,
            jwplayer
        },
        name: 'resources',
        metaInfo () {
            let self = this
            return {
                title: self.metaTag_pageTitle,
                meta: [
                    {name: 'keywords', content: self.metaTag_keywords},
                    {name: 'description', content: self.metaTag_description},
                    {property: 'og:image', content: self.metaTag_fb_image},
                    {property: 'og:title', content: self.metaTag_fb_title},
                    {property: 'og:site_name', content: self.metaTag_fb_sitename},
                    {
                        property: 'og:description',
                        content: self.metaTag_fb_description
                    },
                    {property: 'twitter:title', content: self.metaTag_tw_title},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.metaTag_tw_image},
                    {
                        property: 'twitter:description',
                        content: self.metaTag_tw_description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                hoverState: false,
                shareImagePayload: {
                    corporationId: 0,
                    senderUserId: 0,
                    recipientsUserIds: [],
                    recipientFriendEmails: null,
                    eventId: '',
                    customizedMessage: '',
                    playlistType: 6
                },
                shareEventSelected: null,
                showCorporateImageShare: false,
                corporateShareMessage: '',
                selectedPlaylist: null,
                corpShareModalImage: '',
                showCorporateShare: false,
                corpShareModalTitle: '',
                corpShareModalDesc: '',
                selectedCorps: [],
                allCorps: [],
                shareOption: 'Corporate',
                spinner: false,
                taggedEmails: [],
                emailList: [],
                previewMsg: 'Message Preview: \n',
                showSharedModal: false,
                shareInProcess: false,
                toggleSpinner: false,
                config: {
                    weekends: true,
                    month: true
                },
                monthEvents: [],
                liveEvent: null,
                talkEvent: null,
                currentVideo: null,
                advertisementVideo1: null,
                advertisementVideo2: null,
                reservationMsg: '',
                bannerEvent: '',
                eventURL: 'https://www1.dev-tonenetworks.com',
                sImage: '',
                sTitle: '',
                sDescription: '',
                seatReservation: {
                    userEventId: 0,
                    eventId: 0,
                    userId: 0,
                    status: 0,
                    isAnonymous: 0
                },
                thought1_header: '',
                thought1_text: '',
                thought1_img: '',
                thought1_url: '',
                thought2_header: '',
                thought2_text: '',
                thought2_img: '',
                thought2_url: '',
                thought3_header: '',
                thought3_text: '',
                thought3_img: '',
                thought3_url: '',
                thought4_header: '',
                thought4_text: '',
                thought4_img: '',
                thought4_url: '',
                thought5_header: '',
                thought5_text: '',
                thought5_img: '',
                thought5_url: '',
                article1_header: '',
                article1_text: '',
                article1_img: '',
                article1_url: '',
                article2_header: '',
                article2_text: '',
                article2_img: '',
                article2_url: '',
                article3_header: '',
                article3_text: '',
                article3_img: '',
                article3_url: '',
                article4_header: '',
                article4_text: '',
                article4_img: '',
                article4_url: '',
                article5_header: '',
                article5_text: '',
                article5_img: '',
                article5_url: '',
                resourceCategory1_text: '',
                resourceCategory1_links: [],
                resourceCategory2_text: '',
                resourceCategory2_links: [],
                resourceCategory3_text: '',
                resourceCategory3_links: [],
                resourceCategory4_text: '',
                resourceCategory4_links: [],
                resourceCategory5_text: '',
                resourceCategory5_links: [],
                resourceCategory6_text: '',
                resourceCategory6_links: [],
                siteFeatures1_text: '',
                siteFeatures1_desc: '',
                siteFeatures2_text: '',
                siteFeatures2_desc: '',
                siteFeatures3_text: '',
                siteFeatures3_desc: '',
                siteFeatures4_text: '',
                siteFeatures4_desc: '',
                siteFeatures5_text: '',
                siteFeatures5_desc: '',
                siteFeatures6_text: '',
                siteFeatures6_desc: '',
                siteFeatures7_text: '',
                siteFeatures7_desc: '',
                advertisementBox1_text: '',
                advertisementBox1_video: '',
                advertisementBox1_image: '',
                advertisementBox2_text: '',
                advertisementBox2_video: '',
                advertisementBox2_image: '',
                video1Ref: '',
                adVideo1Ref: '',
                adVideo2Ref: '',
                video_code: '',
                video_title: '',
                metaTag_pageTitle: 'TONE Networks | Resources',
                metaTag_description: '',
                metaTag_keywords: '',
                metaTag_fb_image: '',
                metaTag_fb_title: '',
                metaTag_fb_description: '',
                metaTag_fb_sitename: '',
                metaTag_tw_image: '',
                metaTag_tw_title: '',
                metaTag_tw_description: '',
                subscriptionForm: {
                    userId: null,
                    email: '',
                    name: '',
                    comments: '',
                    rating: 0,
                    newsLetterEmail: '0',
                    promotionalEmail: '0',
                    representativeCall: '0'
                },
                firstAdvertisementBox: null,
                mediaColl: null,
                mediaFile: null,
                advColl: null
            }
        },
        watch: {
            'shareOption' (to, from) {
                let self = this
                self.selectedCorps = null
                self.corporateShareMessage = ''
                self.taggedEmails = []
            }
        },
        mounted: function () {
            let self = this
            setTimeout(function () {
                window.addeventatc.refresh()
            }, 2000)
            this.$store.dispatch('GET_NEWS_RESOURCES').then(() => {
                if (this.getAllNewsResources) {
                    console.log('all resources', this.getAllNewsResources)
                    console.log('all featured articles', this.getAllFeaturedArticles)
                    console.log('all set tone articles', this.getAllSetToneResources)
                    console.log('all advertisement boxes', this.getAllAdvertisementResources)
                    this.mediaColl = this.getAllAdvertisementResources.map(item => {
                        let mediaCol = {}
                        mediaCol.newsResourcesId = item.newsResourcesId
                        mediaCol.videoCode = item.videoCode ? item.videoCode : ''
                        mediaCol.articleHeader = item.articleHeader
                        mediaCol.imageUrl = item.imageUrl
                        mediaCol.videoObject = null
                        return mediaCol
                    })
                    console.log('mediaCol', self.mediaColl)
                    self.returnAdVideo()
                }
            })
            this.$store.dispatch('GETDYNAMICCONTENTS', 11).then(() => {
                if (this.getAllSiteContents) {
                    // Load Meta Tags
                    this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                    this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                    this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                    // OpenGraph Tags
                    this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                    this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                    this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                    this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                    // Twitter Tags
                    this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                    this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                    this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                    // Site Features
                    this.siteFeatures1_text = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT1_HEAD')
                    this.siteFeatures1_desc = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT1_DESC')
                    this.siteFeatures2_text = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT2_HEAD')
                    this.siteFeatures2_desc = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT2_DESC')
                    this.siteFeatures3_text = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT3_HEAD')
                    this.siteFeatures3_desc = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT3_DESC')
                    this.siteFeatures4_text = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT4_HEAD')
                    this.siteFeatures4_desc = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT4_DESC')
                    this.siteFeatures5_text = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT5_HEAD')
                    this.siteFeatures5_desc = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT5_DESC')
                    this.siteFeatures6_text = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT6_HEAD')
                    this.siteFeatures6_desc = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT6_DESC')
                    this.siteFeatures7_text = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT7_HEAD')
                    this.siteFeatures7_desc = this.setDynamicSection(this.getAllSiteContents, 'SF_CAT7_DESC')
                    // // 1st THOUGHTS
                    // this.thought1_header = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_HEADER_1') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_HEADER_1').trim()
                    // this.thought1_text = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_DESC_1') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_DESC_1').trim()
                    // this.thought1_img = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_IMAGE_URL_1') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_IMAGE_URL_1').trim()
                    // this.thought1_url = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_URL_1') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_URL_1').trim()
                    // // 1st THOUGHTS
                    // this.thought2_header = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_HEADER_2') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_HEADER_2').trim()
                    // this.thought2_text = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_DESC_2') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_DESC_2').trim()
                    // this.thought2_img = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_IMAGE_URL_2') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_IMAGE_URL_2').trim()
                    // this.thought2_url = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_URL_2') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_URL_2').trim()
                    // // 1st THOUGHTS
                    // this.thought3_header = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_HEADER_3') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_HEADER_3').trim()
                    // this.thought3_text = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_DESC_3') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_DESC_3').trim()
                    // this.thought3_img = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_IMAGE_URL_3') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_IMAGE_URL_3').trim()
                    // this.thought3_url = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_URL_3') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_URL_3').trim()
                    // // 1st THOUGHTS
                    // this.thought4_header = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_HEADER_4') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_HEADER_4').trim()
                    // this.thought4_text = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_DESC_4') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_DESC_4').trim()
                    // this.thought4_img = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_IMAGE_URL_4') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_IMAGE_URL_4').trim()
                    // this.thought4_url = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_URL_4') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_URL_4').trim()
                    // // 1st THOUGHTS
                    // this.thought5_header = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_HEADER_5') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_HEADER_5').trim()
                    // this.thought5_text = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_DESC_5') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_DESC_5').trim()
                    // this.thought5_img = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_IMAGE_URL_5') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_IMAGE_URL_5').trim()
                    // this.thought5_url = this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_URL_5') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'THOUGHTS_URL_5').trim()
                    // 1st Article
                    // this.article1_header = this.setDynamicSection(this.getAllSiteContents, 'FA_HEADER_1')
                    // this.article1_text = this.setDynamicSection(this.getAllSiteContents, 'FA_DESC_1')
                    // this.article1_img = this.setDynamicSection(this.getAllSiteContents, 'FA_IMAGE_URL_1')
                    // this.article1_url = this.setDynamicSection(this.getAllSiteContents, 'FA_URL_1')
                    // // 2nd Article
                    // this.article2_header = this.setDynamicSection(this.getAllSiteContents, 'FA_HEADER_2')
                    // this.article2_text = this.setDynamicSection(this.getAllSiteContents, 'FA_DESC_2')
                    // this.article2_img = this.setDynamicSection(this.getAllSiteContents, 'FA_IMAGE_URL_2')
                    // this.article2_url = this.setDynamicSection(this.getAllSiteContents, 'FA_URL_2')
                    // // 3rd Article
                    // this.article3_header = this.setDynamicSection(this.getAllSiteContents, 'FA_HEADER_3')
                    // this.article3_text = this.setDynamicSection(this.getAllSiteContents, 'FA_DESC_3')
                    // this.article3_img = this.setDynamicSection(this.getAllSiteContents, 'FA_IMAGE_URL_3')
                    // this.article3_url = this.setDynamicSection(this.getAllSiteContents, 'FA_URL_3')
                    // // 4th Article
                    // this.article4_header = this.setDynamicSection(this.getAllSiteContents, 'FA_HEADER_4') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'FA_HEADER_4').trim()
                    // this.article4_text = this.setDynamicSection(this.getAllSiteContents, 'FA_DESC_4') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'FA_DESC_4').trim()
                    // this.article4_img = this.setDynamicSection(this.getAllSiteContents, 'FA_IMAGE_URL_4') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'FA_IMAGE_URL_4').trim()
                    // this.article4_url = this.setDynamicSection(this.getAllSiteContents, 'FA_URL_4') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'FA_URL_4').trim()
                    // // 5th Article
                    // this.article5_header = this.setDynamicSection(this.getAllSiteContents, 'FA_HEADER_5') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'FA_HEADER_5').trim()
                    // this.article5_text = this.setDynamicSection(this.getAllSiteContents, 'FA_DESC_5') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'FA_DESC_5').trim()
                    // this.article5_img = this.setDynamicSection(this.getAllSiteContents, 'FA_IMAGE_URL_5') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'FA_IMAGE_URL_5').trim()
                    // this.article5_url = this.setDynamicSection(this.getAllSiteContents, 'FA_URL_5') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'FA_URL_5').trim()
                    // Resource Categories
                    this.resourceCategory1_text = this.setDynamicSection(this.getAllSiteContents, 'RC_CAT1_HEAD')
                    for (let i = 1; i < 21; i++) {
                        let linkObj = {}
                        let urlkey = `RC_CAT1_LNK${i}_URL`
                        let urlValue = this.setDynamicSection(this.getAllSiteContents, urlkey)
                        let textkey = `RC_CAT1_LNK${i}_TEXT`
                        let textValue = this.setDynamicSection(this.getAllSiteContents, textkey)
                        if (urlValue) {
                            linkObj.url = urlValue
                            linkObj.title = textValue
                            self.resourceCategory1_links.push(linkObj)
                        }
                    }
                    this.resourceCategory2_text = this.setDynamicSection(this.getAllSiteContents, 'RC_CAT2_HEAD')
                    for (let i = 1; i < 21; i++) {
                        let linkObj = {}
                        let urlkey = `RC_CAT2_LNK${i}_URL`
                        let urlValue = this.setDynamicSection(this.getAllSiteContents, urlkey)
                        let textkey = `RC_CAT2_LNK${i}_TEXT`
                        let textValue = this.setDynamicSection(this.getAllSiteContents, textkey)
                        if (urlValue) {
                            linkObj.url = urlValue
                            linkObj.title = textValue
                            self.resourceCategory2_links.push(linkObj)
                        }
                    }
                    this.resourceCategory3_text = this.setDynamicSection(this.getAllSiteContents, 'RC_CAT3_HEAD')
                    for (let i = 1; i < 21; i++) {
                        let linkObj = {}
                        let urlkey = `RC_CAT3_LNK${i}_URL`
                        let urlValue = this.setDynamicSection(this.getAllSiteContents, urlkey)
                        let textkey = `RC_CAT3_LNK${i}_TEXT`
                        let textValue = this.setDynamicSection(this.getAllSiteContents, textkey)
                        if (urlValue) {
                            linkObj.url = urlValue
                            linkObj.title = textValue
                            self.resourceCategory3_links.push(linkObj)
                        }
                    }
                    this.resourceCategory4_text = this.setDynamicSection(this.getAllSiteContents, 'RC_CAT4_HEAD')
                    for (let i = 1; i < 21; i++) {
                        let linkObj = {}
                        let urlkey = `RC_CAT4_LNK${i}_URL`
                        let urlValue = this.setDynamicSection(this.getAllSiteContents, urlkey)
                        let textkey = `RC_CAT4_LNK${i}_TEXT`
                        let textValue = this.setDynamicSection(this.getAllSiteContents, textkey)
                        if (urlValue) {
                            linkObj.url = urlValue
                            linkObj.title = textValue
                            self.resourceCategory4_links.push(linkObj)
                        }
                    }
                    this.resourceCategory5_text = this.setDynamicSection(this.getAllSiteContents, 'RC_CAT5_HEAD')
                    for (let i = 1; i < 21; i++) {
                        let linkObj = {}
                        let urlkey = `RC_CAT5_LNK${i}_URL`
                        let urlValue = this.setDynamicSection(this.getAllSiteContents, urlkey)
                        let textkey = `RC_CAT5_LNK${i}_TEXT`
                        let textValue = this.setDynamicSection(this.getAllSiteContents, textkey)
                        if (urlValue) {
                            linkObj.url = urlValue
                            linkObj.title = textValue
                            self.resourceCategory5_links.push(linkObj)
                        }
                    }
                    this.resourceCategory6_text = this.setDynamicSection(this.getAllSiteContents, 'RC_CAT6_HEAD')
                    for (let i = 1; i < 21; i++) {
                        let linkObj = {}
                        let urlkey = `RC_CAT6_LNK${i}_URL`
                        let urlValue = this.setDynamicSection(this.getAllSiteContents, urlkey)
                        let textkey = `RC_CAT6_LNK${i}_TEXT`
                        let textValue = this.setDynamicSection(this.getAllSiteContents, textkey)
                        if (urlValue) {
                            linkObj.url = urlValue
                            linkObj.title = textValue
                            self.resourceCategory6_links.push(linkObj)
                        }
                    }
                    // Video Reference
                    this.video_code = this.setDynamicSection(this.getAllSiteContents, 'VIDEO_CODE')
                    this.video_title = this.setDynamicSection(this.getAllSiteContents, 'VIDEO_TITLE')
                    // Advertisement Boxes
                    // this.advertisementBox1_text = this.setDynamicSection(this.getAllSiteContents, 'ADVERTISE_BOX1_TEXT') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'ADVERTISE_BOX1_TEXT').trim()
                    // this.advertisementBox1_image = this.setDynamicSection(this.getAllSiteContents, 'ADVERTISE_BOX1_IMAGE') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'ADVERTISE_BOX1_IMAGE').trim()
                    // this.advertisementBox1_video = this.setDynamicSection(this.getAllSiteContents, 'ADVERTISE_BOX1_VIDEO') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'ADVERTISE_BOX1_VIDEO').trim()
                    // this.advertisementBox2_text = this.setDynamicSection(this.getAllSiteContents, 'ADVERTISE_BOX2_TEXT') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'ADVERTISE_BOX2_TEXT').trim()
                    // this.advertisementBox2_image = this.setDynamicSection(this.getAllSiteContents, 'ADVERTISE_BOX2_IMAGE') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'ADVERTISE_BOX2_IMAGE').trim()
                    // this.advertisementBox2_video = this.setDynamicSection(this.getAllSiteContents, 'ADVERTISE_BOX2_VIDEO') === ' ' ? '' : this.setDynamicSection(this.getAllSiteContents, 'ADVERTISE_BOX2_VIDEO').trim()
                    // Fetch the Videos
                    if (self.video_code && self.video_code.indexOf('http') < 0) { // Not an Image, but a Video Code
                        self.$store.dispatch('GETCURRENTVIDEO', self.video_code).then(() => {
                            if (self.getCurrentVideo) {
                                let videoObj = self.getCurrentVideo[0]
                                self.currentVideo = {
                                    video: videoObj.sources[videoObj.sources.length - 1].file,
                                    title: videoObj.title,
                                    img: videoObj.image,
                                    playerID: new Date(),
                                    tracks: videoObj.tracks,
                                    Description: videoObj.description,
                                    mediaId: videoObj.mediaid,
                                    isMute: true
                                }
                                self.videoRef = window['currentVideoId']
                            }
                        })
                    }
                    // if (self.advertisementBox1_video) {
                    //     self.$store.dispatch('GETCURRENTVIDEO', self.advertisementBox1_video).then(() => {
                    //         if (self.getCurrentVideo) {
                    //             let videoObj = self.getCurrentVideo[0]
                    //             self.advertisementVideo1 = {
                    //                 video: videoObj.sources[videoObj.sources.length - 1].file,
                    //                 title: videoObj.title,
                    //                 img: videoObj.image,
                    //                 playerID: new Date(),
                    //                 tracks: videoObj.tracks,
                    //                 Description: videoObj.description,
                    //                 mediaId: videoObj.mediaid,
                    //                 isMute: true
                    //             }
                    //             self.adVideo1Ref = window['currentVideoId']
                    //         }
                    //     })
                    // }
                    // if (self.advertisementBox2_video) {
                    //     self.$store.dispatch('GETCURRENTVIDEO', self.advertisementBox2_video).then(() => {
                    //         if (self.getCurrentVideo) {
                    //             let videoObj = self.getCurrentVideo[0]
                    //             self.advertisementVideo2 = {
                    //                 video: videoObj.sources[videoObj.sources.length - 1].file,
                    //                 title: videoObj.title,
                    //                 img: videoObj.image,
                    //                 playerID: new Date(),
                    //                 tracks: videoObj.tracks,
                    //                 Description: videoObj.description,
                    //                 mediaId: videoObj.mediaid,
                    //                 isMute: true
                    //             }
                    //         }
                    //         self.adVideo2Ref = window['currentVideoId']
                    //     })
                    // }
                }
                setTimeout(() => {
                    if (self.$route.params.feature) {
                        $('html,body').animate({ scrollTop: $('#sFeatures').offset().top }, 800)
                    }
                }, 1000)
            })
            self.$store.dispatch('GETEVENTLIST').then(() => {
                if (self.getEventList) {
                    self.getEventList.forEach(function (event) {
                        let eveObj = {}
                        eveObj.title = self.getDateReferenceForEvent(event.start_date)
                        eveObj.start = event.start_date
                        eveObj.id = event.eventId
                        eveObj.allDay = true
                        self.monthEvents.push(eveObj)
                    })
                    self.liveEvent = self.getEventList[0]
//                    self.talkEvent = self.getEventList[0]
//                    let liveEvents = self.getEventList.filter(x => {
//                        return x.type === '1'
//                    })
//                    if (liveEvents && liveEvents.length > 0) {
//                        self.liveEvent = liveEvents[0]
//                    }
//                    let talkEvents = self.getEventList.filter(x => {
//                        return x.type === '2'
//                    })
//                    if (talkEvents && talkEvents.length > 0) {
//                        self.talkEvent = talkEvents[0]
//                    }
                }
            })
            if (self.user) {
                // Get Tagged Email List
                self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(() => {
                    if (self.getTaggedEmailList) {
                        self.emailList = []
                        self.emailList = self.getTaggedEmailList
                        console.log('email list', self.getTaggedEmailList)
                    }
                })
                // Get Corporatin Payload if user is part of corporation
                this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(() => {
                    this.allCorps = []
                    if (this.getCorporatePayload) {
                        this.corporateInfo = this.getCorporatePayload
                        this.allCorps = this.corporateInfo.lstCorporationUsers
                    }
                })
            }
            setTimeout(() => {
                self.$store.dispatch('CACHEPAGE', window.location.href)
            }, 2000)
        },
        methods: {
            updateHoverState (isHover) {
                this.hoverState = isHover
            },
            shareCorporateImage () {
                let self = this
                self.shareImagePayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
                self.shareImagePayload.senderUserId = self.user.userId
                self.shareImagePayload.recipientsUserIds = []
                self.shareImagePayload.recipientFriendEmails = null
                self.shareImagePayload.customizedMessage = self.corporateShareMessage
                if (self.shareOption === 'Corporate') {
                    self.shareImagePayload.recipientsUserIds = []
                    self.shareImagePayload.recipientFriendEmails = null
                } else if (self.shareOption === 'Individual') {
                    self.shareImagePayload.recipientFriendEmails = null
                    if (self.selectedCorps && self.selectedCorps.length > 0) {
                        self.shareImagePayload.recipientsUserIds = self.selectedCorps.map(x => {
                            return x.userId
                        })
                    }
                } else if (self.shareOption === 'Friends') {
                    self.shareImagePayload.recipientsUserIds = []
                    let emailArray = self.taggedEmails.map(x => {
                        return x.name
                    })
                    self.shareImagePayload.recipientFriendEmails = emailArray.join(',')
                } else {
                }
                self.shareImagePayload.eventId = self.shareEventSelected.eventId
                self.shareInProcess = true
                // Send the Email
                self.$store.dispatch('CORP_EVENT_SHARE', {payload: self.shareImagePayload}).then(() => {
                    if (!self.error.show) {
                        self.spinnerToggle()
                        self.$swal({
                            title: 'Event has been shared!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        // self.shareInProcess = false
                        // self.spinnerToggle()
                        self.cancelCorporateImageModal()
                    } else {
                        // self.shareInProcess = false
                        // self.spinnerToggle()
                        self.cancelCorporateImageModal()
                    }
                })
            },
            maskEmailAddress (userEmail) {
                let avg, splitted, part1, part2
                splitted = userEmail.split('@')
                part1 = splitted[0]
                let regex = /[^0-9.]/g
                let maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1)
                console.log('maked', maskid)
                avg = part1.length / 2
                part1 = part1.substring(0, (part1.length - avg))
                part2 = splitted[1]
                let maskDomain = part2.split('.')
                return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1]
            },
            customLabel (option) {
                let findDuplicate = this.allCorps.find(x => {
                    return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId
                })
//            console.log('findDuplicate', findDuplicate)
                if (findDuplicate) {
                    let maskedEmail = this.maskEmailAddress(option.email)
                    return `${option.firstName} ${option.lastName} <${maskedEmail}>`
                } else {
                    return `${option.firstName} ${option.lastName}`
                }
            },
            openCorporateImageShareModal () {
                let self = this
                let tEvent = self.liveEvent
                console.log('event for share', tEvent)
                self.shareInProcess = false
                self.shareEventSelected = tEvent
                self.corpShareModalImage = tEvent.img_url
                self.corpShareModalDesc = tEvent.description
                self.corpShareModalTitle = tEvent.title
                self.showCorporateImageShare = true
            },
            verifyEmailShare (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            addTag (newTag) {
                let self = this
                console.log('newTAg', newTag)
                const tag = {
                    name: newTag
                }
                if (self.verifyEmailShare(newTag)) {
                    self.emailList.push(tag)
                    this.taggedEmails.push(tag)
                    console.log('tagged emails', this.taggedEmails)
                } else {
                    console.log('invalid email address, calling swal')
                    // self.$swal({
                    //     title: 'Invalid Email Address',
                    //     text: 'Please enter valid email address',
                    //     type: 'error',
                    //     timer: 2000,
                    //     showCancelButton: false,
                    //     showConfirmButton: false
                    // }).then(
                    //     function () {
                    //     },
                    //     // handling the promise rejection
                    //     function (dismiss) {
                    //         if (dismiss === 'timer') {
                    //         }
                    //     }
                    // )
                }
            },
            cancelCorporateImageModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showCorporateImageShare = false
                    self.shareInProcess = false
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            returnAdVideo () {
                let self = this
                self.mediaColl.forEach(item => {
                    if (item.videoCode) {
                        self.$store.dispatch('GET_CURRENT_VIDEO_DATA_SYNC', item.videoCode).then((res) => {
                            if (res) {
                                let videoObj = res[0]
                                let videoObject = {
                                    video: videoObj.sources[videoObj.sources.length - 1].file,
                                    title: videoObj.title,
                                    img: videoObj.image,
                                    playerID: new Date(),
                                    tracks: videoObj.tracks,
                                    Description: videoObj.description,
                                    mediaId: videoObj.mediaid,
                                    isMute: true
                                }
                                if (videoObject) {
                                    item.videoObject = videoObject
                                }
                                // self.mediaFile = videoObject
                                // return self.mediaFile
                            } else {
                                return null
                            }
                        })
                    }
                })
                this.firstAdvertisementBox = this.mediaColl.shift()
                console.log('first advertisement', this.firstAdvertisementBox)
                console.log('remaining advertisement', this.mediaColl)
            },
            calendarLogging (event, title) {
                let self = this
                let userPayload = []
                let uId = 0
                if (self.user) {
                    uId = self.user.userId
                }
                userPayload.push(uId)
                userPayload.push(self.$route.fullPath)
                userPayload.push('ADD_TO_CALENDAR')
                userPayload.push(title)
                self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload)
            },
            eventSelected (event, jsEvent, view) {
                let selectedEvent = event.id
                let findEvent = this.getEventList.filter(x => {
                    return x.eventId === selectedEvent
                })
                if (findEvent && findEvent.length > 0) {
                    this.talkEvent = findEvent[0]
                    setTimeout(function () {
                        window.addeventatc.refresh()
                    }, 1000)
                }
            },
            verifyEmail (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            onEmailSignUp () {
                var self = this
                this.subscriptionForm.comments = 'Newsletter Subscription'
                this.subscriptionForm.newsLetterEmail = '1'
                this.displayMsg = 'Successfully subscribed to newsletter'
                this.subscriptionForm.email = this.subscriptionForm.email.toLowerCase()
                if (self.verifyEmail(this.subscriptionForm.email)) {
                    this.$store.dispatch('SENDFEEDBACKFORM', this.subscriptionForm).then(() => {
                        window.logEvents('Newsletter subscription', 'Subscribed', `Newsletter subscribed by ${this.subscriptionForm.email}`)
                        // this.successMsg = 'Successfully Subscribed'
                        self.$swal({
                            title: this.displayMsg,
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        setTimeout(() => {
                            this.subscriptionForm.email = ''
                            this.subscriptionForm.promotionalEmail = '0'
                            this.subscriptionForm.userId = null
                            this.subscriptionForm.email = ''
                            this.subscriptionForm.name = ''
                            this.subscriptionForm.comments = ''
                            this.subscriptionForm.rating = 0
                            this.subscriptionForm.newsLetterEmail = '0'
                            this.subscriptionForm.promotionalEmail = '0'
                            this.subscriptionForm.representativeCall = '0'
                        }, 2000)
                    })
                }
            },
            openPanel (key) {
                let param = this.$route.params.feature
                if (param) {
                    if (key.toLowerCase().replace(/\s+/g, '') === param.toLowerCase().replace(/\s+/g, '')) {
                        return true
                    } else {
                        return false
                    }
                }
                return false
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            getDateReferenceForEvent (dte) {
                let dt = new Date(dte)
                let eHours = this.getHoursFormattedForEvents(dt)
                return `${eHours} ET`
            },
            getDateReference (dte, type) {
                let dt = new Date(dte)
                let dayStr, monStr
                let eDay = dt.getDate()
                let eHours = this.getHoursFormatted(dt)
                let eMonth = dt.getMonth() + 1
                let day
                // Set Day of Date
                if (dt.getDay() === 0) {
                    day = 'Sunday'
                } else if (dt.getDay() === 1) {
                    day = 'Monday'
                } else if (dt.getDay() === 2) {
                    day = 'Tuesday'
                } else if (dt.getDay() === 3) {
                    day = 'Wednesday'
                } else if (dt.getDay() === 4) {
                    day = 'Thursday'
                } else if (dt.getDay() === 5) {
                    day = 'Friday'
                } else if (dt.getDay() === 6) {
                    day = 'Saturday'
                } else {
                    day = ''
                }
                // Set Date Pattern
                if (eDay === 1) {
                    dayStr = '1st'
                } else if (eDay === 2) {
                    dayStr = '2nd'
                } else if (eDay === 3) {
                    dayStr = '3rd'
                } else if (eDay === 21) {
                    dayStr = '21st'
                } else if (eDay === 22) {
                    dayStr = '22nd'
                } else if (eDay === 23) {
                    dayStr = '23rd'
                } else if (eDay === 31) {
                    dayStr = '31st'
                } else {
                    dayStr = eDay + 'th'
                }
                // Set Month
                if (eMonth === 1) {
                    monStr = 'January'
                } else if (eMonth === 2) {
                    monStr = 'February'
                } else if (eMonth === 3) {
                    monStr = 'March'
                } else if (eMonth === 4) {
                    monStr = 'April'
                } else if (eMonth === 5) {
                    monStr = 'May'
                } else if (eMonth === 6) {
                    monStr = 'June'
                } else if (eMonth === 7) {
                    monStr = 'July'
                } else if (eMonth === 8) {
                    monStr = 'August'
                } else if (eMonth === 9) {
                    monStr = 'September'
                } else if (eMonth === 10) {
                    monStr = 'October'
                } else if (eMonth === 11) {
                    monStr = 'November'
                } else if (eMonth === 12) {
                    monStr = 'December'
                }
                if (type === 'btn') {
                    return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!'
                } else if (type === 'live') {
                    return monStr + ' ' + eDay
                } else if (type === 'live2') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else if (type === 'str') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else {
                    return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET'
                }
            },
            getExpertInfo (expertId, info) {
                let reqInfo
                if (this.getAllExperts) {
                    let expert = this.getAllExperts.filter(exp => {
                        return exp.expertId === expertId
                    })
                    if (info === 'name') {
                        reqInfo = expert[0].name
                    } else if (info === 'img') {
                        reqInfo = expert[0].small_image
                    } else if (info === 'biography') {
                        reqInfo = expert[0].biography
                    } else if (info === 'experties') {
                        reqInfo = expert[0].experties
                    }
                }
                return reqInfo
            },
            getHoursFormattedForEvents (time) {
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'pm' : 'am'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = hours + ':' + minutes + '' + ampm
                return strTime
            },
            getHoursFormatted (time) {
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'pm' : 'am'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = hours + ':' + minutes + ' ' + ampm
                return strTime
            },
            isUserEntrolled (eventId) {
                if (this.getUserEvents) {
                    let filter = this.getUserEvents.filter(ev => {
                        return ev.eventId === eventId
                    })
                    if (filter && filter.length > 0) {
                        return true
                    }
                }
                return false
            },
            getMinutesBetweenDates (startDate, endDate) {
                var diff = endDate.getTime() - startDate.getTime()
                return (diff / 60000)
            },
            isEventToday (evtDate) {
                let eventDate = new Date(evtDate)
                let currentDate = this.returnEasternTime()
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) >= 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            isEventToday2 (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
                let eventDate = new Date(evtDate)
                let eventEndDate = new Date(endDate)
                let currentDate = this.returnEasternTime()
                let switchTime = parseInt(defaultSwitchTime)
                if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                    switchTime = parseInt(eventSwtichTime)
                }
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            timeLeftInEvent (evtDate) {
                let eventDate = new Date(evtDate)
                let currentDate = this.returnEasternTime()
                return this.getMinutesBetweenDates(currentDate, eventDate)
            },
            showJoin (bEvent) {
                if (bEvent) {
                    if (this.isEventToday2(bEvent.start_date, bEvent.end_date, bEvent.eventSwitchTime, this.getEventSwitchTime)) {
                        return true
                    }
                }
                return false
            },
            joinEvent (event) {
                if (this.user) {
                    this.$router.push(`/event/${event.eventId}`)
                } else {
                    if (sessionStorage.getItem('redirectPath')) {
                        sessionStorage.removeItem('redirectPath')
                        sessionStorage.setItem('redirectPath', `/event/${event.eventId}`)
                    } else {
                        sessionStorage.setItem('redirectPath', `/event/${event.eventId}`)
                    }
                    store.commit('setTriggerLogin', {loginStatus: true})
                }
                // this.$router.push(`/rules/` + event.eventId)
            },
            enrollUser (event) {
                if (event.eventId === 1) {
                    window.logEvents('Events Page', 'Tone Live Seat Reserved', `Event Title: ${event.title}`)
                } else {
                    window.logEvents('Events Page', 'Tone Talk Seat Reserved', `Event Title: ${event.title}`)
                }
                this.seatReservation.eventId = event.eventId
                this.seatReservation.userId = this.user.userId
                this.seatReservation.status = '1'
                this.seatReservation.isAnonymous = '0'
                this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(() => {
                    this.$store.dispatch('GETALLEXPERTS').then(() => {
                    })
                    this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                    })
                })
            },
            returnEasternTime () {
                let offset = -5
                if (dateHelpers.dstEnabled(new Date())) {
                    offset = -4.0
                }
                let clientDate = new Date()
                let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)
                let serverDate = new Date(utc + (3600000 * offset))
                return serverDate
            },
            triggerLogin () {
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath')
                    sessionStorage.setItem('redirectPath', `/events`)
                } else {
                    sessionStorage.setItem('redirectPath', `/events`)
                }
                store.commit('setTriggerLogin', {loginStatus: true})
            },
            buildEventLink (EVENT_ID) {
                let href = window.location.href
                let calendarLink = ''
                console.log('Community.vue -> buildEventLink() : href = ', href)
                console.log('Community.vue -> buildEventLink() : EVENT_ID = ', EVENT_ID)
                if (this.user && this.user.corporation && this.user.corporation.corporationId === 200) {
                    if (href.indexOf('localhost') > -1 || href.indexOf('dev') > -1) {
                        calendarLink = 'https://www1.dev-tonenetworks.com/horizonssotest?corporationId=200&redirect_uri=https://www1.dev-tonenetworks.com/event/' + EVENT_ID // this.getMainEvent.eventId
                    } else {
                        calendarLink = 'https://www.tonenetworks.com/horizonsso?corporationId=200&redirect_uri=https://www.tonenetworks.com/event/' + EVENT_ID // this.getMainEvent.eventId
                    }
                    //  https://www.tonenetworks.com/horizonsso?corporationId=200&redirect_uri=https://www.tonenetworks.com/event/294
                } else {
                    calendarLink = this.eventURL + '/event/' + EVENT_ID // this.getMainEvent.eventId
                    // https://www.tonenetworks.com/event/294
                }
                return calendarLink
            }
        },
        computed: {
            ...mapGetters([
                'user', 'error', 'getExpert', 'getEventList', 'getMainEvent', 'getTalkEvents', 'getLiveEvents', 'getLiveExperts', 'getTalkExperts', 'getBannerEvent', 'getMonthEvents', 'getCurrentVideo',
                'getAllSiteContents', 'getEventSwitchTime', 'getAllNewsResources', 'getAllFeaturedArticles', 'getAllSetToneResources', 'getAllAdvertisementResources', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getTaggedEmailList', 'getCorporatePayload']
            ),
            styleObject () {
                if (this.hoverState) {
                    return {
                        color: '#FFFFFF',
                        backgroundColor: this.getCorpButtonColor,
                        borderColor: this.getCorpButtonColor
                    }
                } else {
                    return {
                        // border: '2px solid' + this.getCorpButtonColor + ' !important',
                        color: this.getCorpButtonColor,
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: this.getCorpButtonColor
                        // borderColor: this.getCorpButtonColor
                    }
                }
            }
        }

    }
</script>
<style scoped>
    .col-sm-7 .container-responsive h4 {
        color: #f0617d;
        border-bottom: 2px solid #f0617d;
        padding-bottom: 10px;
        margin-bottom: 15px;
    }
    .resource-content .sliderEventBox .slick-slide img {
        object-fit: cover;
        object-position: center;
        height:auto;
    }
    .sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent {
        border-radius: 3px;
        margin: 20px 0 0;
    }

    .sliderEventBox p {
        min-height: 155px;
    }
    /*.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent.disabled ,*/
    /*.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent.disabled:hover {*/
    /*background: transparent;*/
    /*color: #e08383 !important;*/
    /*}*/
    @media(min-width:768px){
        .sliderTalkBox>h2+p {
            position: relative;
            top: -40px;
            color: #303030;
            font-size: 15px;
            font-weight: 500;
            font-family: sans-serif;
            letter-spacing: 0.3px;
        }
        .resource-content .sliderEventBox {
            margin: 70px 0 100px 0;
        }
    }
    .resource-content .communityBox button{width:auto;}
    .resource-content .communityBox h5 {
        margin: 0 0 35px 0;
    }
    .resource-content .sliderTalkBox .slick-slide p {
        margin: 0 0 20px 0;
        color: #303030;
        font-size: 14px;
        line-height: 22px;
        font-family: sans-serif;
        padding: 0 10px 0 10px;
        text-align: left;
        letter-spacing: 0.5px;
    }
    .selected-event {
        content: "\F00C";
        font: normal normal normal 14px/1 FontAwesome;
        position: absolute;
        color: white;
        right: 20.5px;
        top: 24px;
        font-size: 18px;
    }
    .slick-slide button.button {
        color: #f0617d;
        border: 1px solid #f0617d;
        background: none;
        outline: none;
        font-size: 16px;
        font-family: sans-serif;
        letter-spacing: 0.3px;
        float: left;
        margin-left: 10px;
        width: 278px;
        padding: 18px 15px 14px;
        border-radius: 3px;
        margin-top: 10px;
    }
    .sliderTalkBox .slider p {
        min-height: 160px;
    }
    .resource-content .sliderTalkBox .slick-slide h5 {
        text-align: left;
        padding: 0 10px;
    }
    .sliderTalkBox .slider h2{
        color: #303030;
        margin: 15px 0 15px 0;
        line-height: 31px;
        text-align: left;
        font-family: sans-serif;
        padding: 0 20px 0 10px;
        font-size: 20px;
        text-transform: inherit;
    }


    img {
        max-width: 100%;
    }

    .container-responsive {
        text-align: left;
    }
    h3 {
        background: #f0617d;
        color: #fff;
        padding: 5px;
    }

    h4 {
        font-weight: 900;
        font-size: 18px;
    }
    .smlbuttonholder {
        padding: 20px 0 30px;
    }

    .fc .fc-toolbar>*>h2 {
        font-size: 21px;
        font-weight: 900;
        color: #232323;
        letter-spacing: 0;
    }
    .advertizmentbox {
        border: 2px solid #ddd;
        margin: 0 0 30px;
        /*padding: 20px;*/
    }

    /*.advertizmentbox:empty:after {
        content: "Advertisement Box";
        display: block;
        text-align: center;
        padding: 70px 0;
        font-weight: 900;
    }*/
    button.yellowbtn {
        background: #f7f75e;
        border: 0 none transparent;
        padding: 8px 20px;
        line-height: 1;
        display: block;
        margin: 0 auto 20px;
        border-radius: 30px;
    }

    .socialblocks > a >i {
        color: #fff;
        margin: 0 0 0;
        line-height: 70px;
        display: block;
    }

    .socialblocks > a {
        background: #f0617d;
        width: 70px;
        display: inline-block;
        text-align: center;
        line-height: 70px;
    }

    .socialblocks > a {}

    .socialblocks {
        display: flex;
        justify-content: space-between;
    }
    h3.adboxheading {
        margin-bottom: 30px;
    }
    .container {
        padding-bottom: 50px;
    }
    /*Changes for Corporate Modal*/
    .sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader {
        background: #f0617d;
        color: #fff;
        font-size: 25px;
        text-align: left;
        padding: 15px 25px;
        font-weight: 700;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body p{
        padding: 0;
        margin: 0 0 20px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
        background: #fff;
        color: #333;
        border: 1px solid #cacaca;
        width: 100%;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body {
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink {
        background: #f0617d;
        width: 100%;
        margin: 0;
        border: 1px solid #f0617d;
    }
    @media(max-width:475px){
        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
            padding-left: 0;
            padding-right: 0;
        }
    }
    .row.sharefb {
        background: #eee;
        margin-left: 0;
        margin-right: 0;
    }

    .row.sharefb > div {
        padding: 5px;
        text-align: left;
    }

    .row.sharefb .col-sm-5 img {
        max-width: 100%;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
        font-size: 14px;
        font-weight: 300;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6 {
        text-transform: uppercase;
        font-size: 12px;
        margin: 10px 0 5px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4 {
        margin: 0 0 5px;
        font-weight:700;
    }
    .showmobile{display:none;}
    @media(max-width:767px){
        .usernamenimg.text-left {
            display: none;
        }
        .showmobile{
            display: block;
        }
        .alert.alert-default {
            background: #eee;
        }

        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
            display: none;
        }
        .sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow {
            top: 1px;
            right: -13px;
        }
        .row.sharefb {
            display: flex;
            align-items: center;
        }
        .pinksidebarmin{
            padding:0 !important;
            display: flex;
            flex-direction: column;
            flex-basis: auto;
            display: flex ;
            align-items: stretch ;
            justify-content: center;
        }

        .pinksidebarmin > * {
            padding: 6px 0 !important;
            margin: 0 !important;
            flex: 100;
            text-align:center;
        }
    }
    .watchVideoModal .modal-dialog .modal-body p {
        padding: 16px 60px 19px 60px;
    }
    .modal {
        z-index: 999999;
    }

</style>
<style>
    button.fc-prev-button.fc-button.fc-state-default.fc-corner-left {
        display: none;
    }

    .fc-right {
        display: none;
    }

    button.fc-next-button.fc-button.fc-state-default.fc-corner-right {
        display: none;
        /*background: #f0617d;*/
        /*color: #fff;*/
        /*text-shadow: 0 0 0 transparent;*/
        /*border: 0;*/
        /*border-radius: 0;*/
        /*float: right;*/
    }

    .fc-button-group {
        position: absolute;
        right: 15px;
    }

    .calendarholder .fc-today-button {
        display: none;
    }
    .resource-content .fc-content-skeleton span.fc-title:before {
        content: "\f005";
        font-family: fontawesome;
        color:#efc662;
    }
    .resource-content .fc-content-skeleton span.fc-title {
        white-space: normal;
        word-wrap:break-word;
    }
    .resource-content .fc-scroller.fc-day-grid-container {
        height: auto !important;
        overflow: visible !important;
    }
    .accordionholder .panel-collapse:after {
        /*border: 1px solid #f0617d;*/
        /*position: absolute;*/
        /*content: "";*/
        /*top: 0;*/
        /*left: 0;*/
        /*right: 0;*/
        /*bottom: 0;*/
    }

    .accordionholder .panel.panel-default {
        position: relative;
    }
    .accordionholder .panel-body a {
        font-weight: bold;
        text-decoration: underline;
    }

    .accordionholder .panel-body a:before {
        position: relative;
        display: inline-block;
        content: "";
        width: 10px;
        height: 10px;
        background: #f0617d;
        border-radius: 50%;
        margin-right: 10px;
    }
    button.share-event {
        color: rgb(240, 97, 125) !important;
        border: 1px solid rgb(240, 97, 125) !important;
        background-image: none !important;
        font-weight: 600;
        line-height: 100%;
        background: #fff !important;
        font-size: 15px !important;
        text-decoration: none;
        border-radius: 3px !important;
        cursor: pointer;
        -webkit-font-smoothing: antialiased!important;
        outline-color: rgba(0,78,255,0.5) !important;
        text-shadow: 1px 1px 1px rgb(0 0 0 / 0%);
        display: inline-block;
        position: relative;
        /*z-index: 99998;*/
        font-family: "Open Sans",Roboto,"Helvetica Neue",Helvetica,Optima,Segoe,"Segoe UI",Candara,Calibri,Arial,sans-serif !important;
        padding: 12px 12px 12px 12px !important;
        margin-left: 10px !important;
        width: 173px !important;
        display: inline-block;
        float: left !important;
        box-shadow: 0 0 0 0.5px rgba(50,50,93,.17), 0 2px 5px 0 rgba(50,50,93,.1), 0 1px 1.5px 0 rgba(0,0,0,.07), 0 1px 2px 0 rgba(0,0,0,.08), 0 0 0 0 transparent!important;
    }
    .addeventatc.pinkoutlinebtn {
        float: left;
    }
    @media(max-width:991px){
 .addeventatc.pinkoutlinebtn{
margin-left:0 !important;
margin-right:10px;
margin-bottom:10px;
}
 button.share-event{
margin-left:0 !important;
}
}
@media(max-width:767px){
.addeventatc.pinkoutlinebtn{margin-left:10px !important;}
button.share-event{
margin-left:5px !important;
}
}

</style>



// WEBPACK FOOTER //
// Resources.vue?391b8c7f